import { Button, Stack, Typography } from "@mui/material";

const Error404 = () => {
  return (
    <Stack spacing={2}>
      <Typography variant="h1">404</Typography>
      <Typography variant="h3">We are sorry</Typography>
      <Typography variant="body1">
        It seems that the page you&apos;re trying to reach either doesn&apos;t exist or you
        don&apos;t have access to it. Try to reach one of the other dashboards.
      </Typography>
      <Button
        href="/dashboards"
        fullWidth={false}
        variant="contained"
        sx={{ alignSelf: "flex-start" }}
      >
        Dashboard Overview
      </Button>
    </Stack>
  );
};

export default Error404;
